import { useLocation } from 'react-router-dom'
import { useQuestionnaireParams } from 'hooks/useQuestionnaireParams'

export function useFdChatUrl() {
  const mandatoryParams = useQuestionnaireParams()
  const location = useLocation()

  const { surveyId, respondentId } = mandatoryParams ?? {}
  const searchParams = new URLSearchParams(location.search)
  searchParams.set('hybrid', 'true')

  const participantExperienceDomains =
    process.env.REACT_APP_PARTICIPANT_EXPERIENCE_REDIRECT_SOURCES?.split(
      ','
    ).map((domain) => domain.trim()) || []
  const shouldRedirectToParticipantExperience =
    participantExperienceDomains.includes(searchParams.get('source') ?? '')

  // If the project is a coworker project we should redirect to the participant experience domain
  if (shouldRedirectToParticipantExperience) {
    searchParams.set('rid', respondentId)
    return {
      url: `${process.env.REACT_APP_PARTICIPANT_EXPERIENCE_DOMAIN}/interview/${surveyId}?${searchParams}`,
      shouldRedirectToParticipantExperience: true
    }
  }

  return {
    url: `${process.env.REACT_APP_FDCHAT_DOMAIN}/${surveyId}/${respondentId}?${searchParams}`,
    shouldRedirectToParticipantExperience: false
  }
}
